
import theNav from "@/components/layout/nav.vue"
import theSidebar from "@/components/layout/sidebar.vue"
import MobileUpload from "@/views/mobile/MobileUpload.vue"
import { defineComponent, nextTick, onMounted, onUnmounted, provide, ref } from "vue"
import { startAppVersionCheck } from "@/util/app-version"
import MobileIndex from "./views/mobile/MobileIndex.vue";

export default defineComponent({
  components: {
    theNav,
    theSidebar,
    MobileIndex
  },
  setup() {
    const isReload = ref(true)
    const isMobileView = ref(false)
    let stopVersionCheck: (() => void) | undefined

    const reload = () => {
      isReload.value = false
      nextTick(() => {
        isReload.value = true
      })
    }

    const checkIsMobile = () => {
      const userAgent = navigator.userAgent
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
      isMobileView.value = isMobileDevice
    }

    const handleSwitchToDesktop = () => {
      isMobileView.value = false
    }

    onMounted(() => {
      checkIsMobile()
      stopVersionCheck = startAppVersionCheck()
    })

    onUnmounted(() => stopVersionCheck?.())

    provide("reload", reload)

    return {
      isReload,
      isMobileView,
      handleSwitchToDesktop,
      title: document.title
    }
  },
})
